import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

import { ConsoleRestrictedColumnsSummary } from './getConsoleRestrictedColumnsQuery';

const ENDPOINT = `${APIConfiguration.seller}console/restrictedColumns`;

export async function UpsertConsoleRestrictedColumnsCommand({
  sellerId,
  importType,
  columnRestrictions,
}: {
  sellerId: string;
  importType: string;
  columnRestrictions: ConsoleRestrictedColumnsSummary[];
}): Promise<BaseBackResponse | BackResponseFailure> {
  try {
    const response = await apiCall<BaseBackResponse>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: { sellerId, importType, columnRestrictions },
    });

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}
